import { useState } from "react";
import { useTimer } from "@/components/hooks/utility/useTimer";



const UseApprovePanel = ({onApprovalClick} : {onApprovalClick: any}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const needsApprovedText : string = "Needs Approval";
    const approvedStateText : string = "Approved";
    const pendingApproveStateText : string = "Approve";
    const pendingApproveStateAriaLabel : string = "Approve and Publish this content";
    const loadingAriaLabel : string = "Approving content";

    function onButtonClick() {
        setIsLoading(true);
        onApprovalClick();
    }

    useTimer(isLoading, ()=>setIsLoading(false), 3000);

    return {
        isLoading, setIsLoading, onButtonClick, needsApprovedText, approvedStateText, pendingApproveStateText, pendingApproveStateAriaLabel, loadingAriaLabel
    };
};

export default UseApprovePanel